!(function(root, factory) {
    "use strict";
    "function" == typeof define && define.amd
        ? define(["analyticstracker"], function(analyticstracker) {
              return (root.analyticsTransGTM = factory(
                  analyticstracker,
                  window,
              ));
          })
        : "object" == typeof exports
        ? (module.exports = factory(require("analyticstracker"), window))
        : (root.analyticsTransGTM = factory(root.analyticstracker, window));
})(this, function(analyticstracker, w) {
    "use strict";
    function analyticsTransGTM() {
        if (!(this instanceof analyticsTransGTM))
            return new analyticsTransGTM();
        (this.tracker = analyticstracker()),
            void 0 !== w && null != w && (w.dataLayer = w.dataLayer || []),
            (this._version = "1.0.0"),
            this._subscribe();
    }
    var _instance;
    return (
        (analyticsTransGTM.prototype.getInstance = function() {
            return (_instance = _instance || analyticsTransGTM());
        }),
        (analyticsTransGTM.prototype._subscribe = function() {
            try {
                this.tracker.trackingSubscribe("GTM", function(event, data) {
                    void 0 !== w && null != w && w.dataLayer.push(data);
                });
            } catch (e) {}
        }),
        (_instance = analyticsTransGTM()),
        analyticsTransGTM.prototype.getInstance
    );
});
